function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { loginDefaultValues } from '../../logindefaultValues';
export var createSchema = function(formatMessage, isPhoneInput) {
    var base = {
        Password: Yup.string().test('password', formatMessage('passwordRequired'), function(value, param) {
            var parent = param.parent;
            var NewPassword = parent.NewPassword, CurrentPassword = parent.CurrentPassword;
            if (!NewPassword && !CurrentPassword) {
                return Yup.string().required().min(1).isValidSync(value);
            }
            return true;
        }),
        NewPassword: Yup.string().test('newPassword', formatMessage('newPasswordRequired'), function(value, param) {
            var parent = param.parent;
            var Password = parent.Password, CurrentPassword = parent.CurrentPassword;
            if (!Password && !CurrentPassword) {
                return Yup.string().required().min(1).isValidSync(value);
            }
            return true;
        }),
        CurrentPassword: Yup.string().test('currentPassword', formatMessage('newPasswordRequired'), function(value, param) {
            var parent = param.parent;
            var Password = parent.Password, NewPassword = parent.NewPassword;
            if (!Password && !NewPassword) {
                return Yup.string().required().min(1).isValidSync(value);
            }
            return true;
        }),
        Token: Yup.string().when('Password', {
            is: function(pass) {
                return pass && pass.length > 0;
            },
            // eslint-disable-next-line unicorn/no-thenable -- TODO needs investigaiton
            then: Yup.string(),
            otherwise: Yup.string().required(formatMessage('invalidToken'))
        }),
        LoginName: Yup.string().nullable(),
        LoginPhone: Yup.string().nullable(),
        TempToken: Yup.string().min(1, formatMessage('invalidToken'))
    };
    if (isPhoneInput) {
        base.LoginPhone = Yup.string().nullable().required(formatMessage('usernameRequired')).min(1);
    } else {
        base.LoginName = Yup.string().nullable().required(formatMessage('usernameRequired')).min(1);
    }
    return Yup.object().shape(base).required();
};
export var createFormSettings = function(formatMessage, isPhoneInput, defaultRememberLogin) {
    return {
        defaultValues: _object_spread_props(_object_spread({}, loginDefaultValues), {
            RememberLogin: defaultRememberLogin !== null && defaultRememberLogin !== void 0 ? defaultRememberLogin : loginDefaultValues.RememberLogin
        }),
        resolver: yupResolver(createSchema(formatMessage, isPhoneInput)),
        reValidateMode: 'onChange',
        mode: 'onChange'
    };
};
